<div class="app-shell relative w-full min-h-dvh">
  @if (pullToRefreshService.isPulling()) {
    <div
      class="pointer-events-none fixed left-1/2 top-[calc(0.75rem+var(--app-safe-top))] z-[120] -translate-x-1/2 transition-transform duration-150"
      [style.transform]="'translateX(-50%) translateY(' + pullToRefreshService.pullDistance() + 'px)'"
    >
      <div class="flex items-center gap-2 rounded-full border border-slate-200 bg-white/95 px-3 py-2 text-xs font-medium text-slate-700 shadow-lg backdrop-blur dark:border-slate-700 dark:bg-slate-900/95 dark:text-slate-100">
        <i
          class="fa-solid"
          [class.fa-arrow-rotate-right]="!pullToRefreshService.isRefreshing()"
          [class.fa-spinner]="pullToRefreshService.isRefreshing()"
          [class.fa-spin]="pullToRefreshService.isRefreshing()"
        ></i>
        <span>
          {{ pullToRefreshService.isRefreshing()
            ? 'Actualizando...'
            : pullToRefreshService.isArmed()
              ? 'Suelta para actualizar'
              : 'Desliza para actualizar' }}
        </span>
      </div>
    </div>
  }

  <router-outlet></router-outlet>
  @if (globalLoadingService.isBlockingLoading()) {
    <app-loading class="blocking-loader"></app-loading>
  }
  <app-alert></app-alert>
  <app-modal></app-modal>
  <app-modal-confirm></app-modal-confirm>
</div>
